const SNACK_MAX_DURATION = 7500;
const PRODUCT_LIMIT = 500;
const DEFAULT_DURATION = 7500;
export const WEB_DASHBOARD_URL = 'https://app.bizpluspos.co.ke';
export const LANDING_PAGE_URL = 'https://bizpluspos.co.ke';
export const WEB_LOGIN_URL = 'https://app.bizpluspos.co.ke/login';

export const DEEP_LINK_SCHEME = 'bizplus';
export const DEEP_LINK_HTTPS_HOSTS = ['app.bizpluspos.co.ke'] as const;
export const ADD_PRODUCT_UNAUTHORIZED_MESSAGE =
  'You are not authorized to add products';

export const BACKGROUND_PROMPT_LOGIN = 'prompt-login';

export const IOS_APPSTORE_ID = '6755344493';
export const ANDROID_PACKAGE_NAME = 'com.muriuki.bizpluspos';

const BUSINESS_TYPES = [
  'Agrovet',
  'AutoSpares',
  'Bakery & Pastry',
  'Bar & Restaurant',
  'Beauty & Cosmetics',
  'BookShop',
  'Boutique & Apparel',
  'Butchery',
  'Coffee Shop',
  'General Electronics',
  'Cereals & Grains',
  'Phone Accessories & Repairs',
  'Fruits & Vegetables Vendor',
  'Milk ATM',
  'Stationery & Printing',
  'Furniture and Fittings',
  'Home & Kitchen',
  'Mini Mart',
  'General Shop',
  'Gift Shop',
  'Grocery',
  'Hardware Store',
  'Hotel',
  'Jewelry Store',
  'Kiosk',
  'Pharmacy',
  'Store',
  'Supermarket',
  'Wines and Spirits',
] as const;

export const COUNTRY_CODE_KENYA = '+254';
export const DEFAULT_COUNTRY_CODE = 'KE';
export const DEFAULT_CALLING_CODE = '254';

// Products / ProductList
export const PRODUCT_LIST_SEARCH_LIMIT = 20;
export const PRODUCT_LIST_TOP_BAR_CONTENT_MIN_HEIGHT = 64;

/**
 * Dev-level feature flags. Flip to `false` to fully remove a feature at build
 * time — disables both UI toggles and runtime code paths. User-level toggles
 * in Settings are AND-ed with these (a flag of `false` wins).
 */
export const FEATURE_FLAGS = {
  /** Alphabetical (A–Z) side rail in native product list. Beta. */
  ALPHA_RAIL: true,
} as const;

export { SNACK_MAX_DURATION, PRODUCT_LIMIT, DEFAULT_DURATION, BUSINESS_TYPES };
